import { isDeliveryMeasureEnabledForChannel } from './measure';
import { TransactionalMessageChannelType } from 'cio/models/transactional-message';

export const TRANSACTIONAL_METRICS = [
  'sent',
  'opened',
  'clicked',
  'clicked_to_opened',
  'delivered',
  'unsubscribed',
  'spammed',
  'failed',
  'bounced',
  'suppressed',
] as const;

export function transactionalMetrics(type: TransactionalMessageChannelType) {
  return [...TRANSACTIONAL_METRICS].filter((metric) => isDeliveryMeasureEnabledForChannel(metric, type));
}

export type TransactionalMetric = (typeof TRANSACTIONAL_METRICS)[number];
